<template>
    <div class="timesheet-entry-detail">
        <el-row>
            <el-col :span="12">
                <div class="flex flex-nowrap items-center custom-single-picker">
                    <span class="mr-[12px] font-semibold">Start Date</span>
                    <el-date-picker :disabled-date="disabledDate"  v-model="state.startDate" type="date" placeholder="Start Date"
                        class="h-[40px] w-[180px]" format="DD MMM YYYY" :value-format="'YYYY-MM-DD'" :teleported="true"
                        ref="datePickerStartDate" @focus="onDateFocus" :disabled="disabled" />
                </div>
                <div class="flex flex-nowrap items-center mt-[8px]" v-if="!state.startDate">
                    <div class="ml-[80px]"></div>
                    <div class="font-medium" style="color: #ed1c2d">Please choose start date</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="flex flex-nowrap items-center justify-start">
                    <div>
                        <div class="flex-1 h-10" align="left">
                            <el-button class="btn-time-shift btn-default-2 btn-shift"
                                :class="!state.shift && 'btn-time-shift-selected'" @click="onRequestSwitchShift(false)"
                                :disabled="disabled || !state.shift">
                                <icon-svg :class="state.shift && 'icon-btn-time-shift'" size="24" name="day-shift" />
                                <span class="ml-2.5">Day Shift</span>
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="flex flex-nowrap items-center justify-end">
                    <div>
                        <div class="flex-1 h-10" align="left">
                            <el-button class="btn-time-shift btn-default-2 btn-shift"
                                :class="state.shift && 'btn-time-shift-selected'" @click="onRequestSwitchShift(true)"
                                :disabled="disabled || state.shift">
                                <icon-svg :class="!state.shift && 'icon-btn-time-shift'" size="24" name="night-shift" />
                                <span class="ml-2.5">Night Shift</span>
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div
            class="flex items-center justify-center h-[48px] my-[20px] border border-solid border-[#DEDEDE] rounded-lg">
            <span class="text-xl font-medium">Total:</span>
            <span style="color: #246bfd" class="ml-[5px] text-xl font-medium">{{ totalHoursDisplay }} hrs {{
                totalMinsDisplay }} mins</span>
        </div>
        <div class="mb-[10px]" v-for="(item, index) in state.lines" :key="item.id">
            <el-row class="mb-5">
                <el-col :span="12">
                    <div class="h-[32px] justify-center text-xl font-semibold">
                        <span>{{ `Task ${index + 1}` }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="flex justify-end">
                        <el-button v-if="state.lines.length > 1"
                            class="flex h-[32px] w-[32px] items-center justify-center cursor-pointer task-icon-trash"
                            @click="!disabled && removeLine(item.id)" :disabled="disabled">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.0006 2.66666H11.934C11.615 1.11572 10.2507 0.002 8.6673 0H7.33395C5.75055 0.002 4.38623 1.11572 4.0673 2.66666H2.00064C1.63245 2.66666 1.33398 2.96513 1.33398 3.33331C1.33398 3.7015 1.63245 4 2.00064 4H2.6673V12.6667C2.66952 14.5067 4.16061 15.9978 6.00064 16H10.0006C11.8407 15.9978 13.3318 14.5067 13.334 12.6667V4H14.0006C14.3688 4 14.6673 3.70153 14.6673 3.33334C14.6673 2.96516 14.3688 2.66666 14.0006 2.66666ZM7.33398 11.3333C7.33398 11.7015 7.03552 12 6.66733 12C6.29911 12 6.00064 11.7015 6.00064 11.3333V7.33334C6.00064 6.96516 6.29911 6.66669 6.6673 6.66669C7.03548 6.66669 7.33395 6.96516 7.33395 7.33334V11.3333H7.33398ZM10.0006 11.3333C10.0006 11.7015 9.70217 12 9.33398 12C8.9658 12 8.66733 11.7015 8.66733 11.3333V7.33334C8.66733 6.96516 8.9658 6.66669 9.33398 6.66669C9.70217 6.66669 10.0006 6.96516 10.0006 7.33334V11.3333ZM5.44798 2.66666C5.73155 1.86819 6.48667 1.33434 7.33398 1.33331H8.66733C9.51464 1.33434 10.2698 1.86819 10.5533 2.66666H5.44798Z" />
                            </svg>
                        </el-button>
                        <div class="flex h-[32px] w-[32px] items-center justify-center ml-[20px] cursor-pointer task-icon-duplicate"
                            @click="handleDuplicateLine(item.id)">
                            <el-icon color="#FFFFFF">
                                <CopyDocument />
                            </el-icon>
                        </div>
                        <div class="flex h-[32px] w-[32px] items-center justify-center ml-[20px] cursor-pointer task-icon-expand"
                            @click="toggleExpanded(item.id)">
                            <el-icon color="#FFFFFF">
                                <ArrowDown v-if="!item.expanded" />
                                <ArrowUp v-else />
                            </el-icon>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <div v-show="item.expanded">
                <div class="flex items-center justify-center">
                    <div class="flex flex-row  rounded-group-button">
                        <div v-if="taskTypeDisplay.rental" 
                            class="flex items-center justify-center job-type cursor-pointer task-type"
                            :class="{ 
                                'task-type-selected': item.type === 'Rental',
                                'task-type-disable': disabled
                            }"
                            @click="onRequestSwitchType(item, 'Rental')">
                            <span class="font-semibold">Rental</span>
                        </div>
                        <div v-if="taskTypeDisplay.force"
                            class="flex items-center justify-center job-type cursor-pointer task-type"
                            :class="{ 
                                'task-type-selected': item.type === 'Force',
                                'task-type-disable': disabled
                            }"
                            @click="onRequestSwitchType(item, 'Force')">
                            <span class="font-semibold">Force</span>
                        </div>
                        <!-- <div class="flex items-center justify-center job-type cursor-pointer task-type-right" :class="{ 'task-type-selected': item.type === 'UnBilled' }" @click="setType(item.id, 'UnBilled')">
              <span class="font-semibold">UnBilled</span>
            </div> -->
                    </div>
                </div>

                <div>
                    <el-row class="mt-[20px]">
                        <el-col :span="12">
                            <div class="flex flex-nowrap items-center">
                                <span class="mr-[12px] font-semibold">Start Time</span>
                                <TimePicker
                                    :additionValues="{ id: item.id, isStartTime: true, endTime: toHM(item.endTime) }"
                                    :hours="toHM(item.startTime).hours" :minutes="toHM(item.startTime).minutes"
                                    :isAm="toHM(item.startTime).isAm" :isInit="false" :disable="disabled"
                                    @submit="onSubmitTime" @changeValidTime="onChangeValidTime" />
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="flex flex-nowrap items-center justify-end">
                                <span class="mr-[12px] font-semibold">End Time</span>
                                <TimePicker
                                    :additionValues="{ id: item.id, isEndTime: true, startTime: toHM(item.startTime) }"
                                    :hours="toHM(item.endTime).hours" :minutes="toHM(item.endTime).minutes"
                                     :isAm="toHM(item.endTime).isAm" :isInit="!item.endTime" :disable="disabled"
                                    @submit="onSubmitTime" @changeValidTime="onChangeValidTime" />
                            </div>
                        </el-col>
                    </el-row>
                    <div class="flex justify-center mt-[12px]">
                        <TimesheetEntryTotal
                          :disable="disabled"
                          :hours="item.startTime && item.endTime ? (diffMinutes(item.startTime, item.endTime) / 60) | 0 : 0"
                          :minutes="item.startTime && item.endTime ? diffMinutes(item.startTime, item.endTime) % 60 : 0"
                          :error-message="workingTimeErrorMessage && !workingTimeIsValid && (!item.startTime || !item.endTime) ? workingTimeErrorMessage : undefined"
                          @submit="(v:any) => setLineDuration(item.id, v.hours, v.minutes)"
                        />
                    </div>
                </div>

                <div v-if="item.type === 'Rental'" class="mt-[20px]">
                    <RentalTaskDetail :taskId="item.id" :initial-data="item.originalData" :is-edit-mode="props.isEditMode" :ref="(el) => addRentalTaskRef(el)" :disabled="disabled" />
                </div>

                <div v-if="item.type === 'Force'" class="mt-[20px]">
                    <ForceTaskDetail :taskId="item.id" :initial-data="item.originalData" :is-edit-mode="props.isEditMode" :ref="(el) => addRentalTaskRef(el)" :disabled="disabled" />
                </div>
            </div>
        </div>
        <div>
            <div class="flex-1 h-10 mt-[20px]" align="left">
                <el-button v-if="!disabled" class="btn-bg-color-red btn-default-2 btn-add-task" @click="!disabled && addLine()" :disabled="disabled">
                    <icon-svg size="24" name="plus-circle" />
                    <span class="ml-2.5">Add Task</span>
                </el-button>
            </div>
        </div>
    </div>
    <ConfirmDialog
      v-model:visible="showSwitchConfirm"
      title="Switching Task"
      :message="'You are switching to another task. \nThe existing task data will be deleted.'"
      lblBtnCancel="No"
      lblBtnSubmit="Yes"
      iconBtnName="check-mark-circle"
      iconPopup="warring"
      :width="400"
      @submit="confirmSwitchType"
      @cancel="cancelSwitchType"
    />
    <ConfirmDialog
      v-model:visible="showShiftSwitchConfirm"
      title="Switching Shift"
      :message="'You are switching shift flag;\nthis might affect the input date.\nPlease confirm.'"
      lblBtnCancel="No"
      lblBtnSubmit="Yes"
      iconBtnName="check-mark-circle"
      iconPopup="warring"
      :width="400"
      @submit="confirmSwitchShift"
      @cancel="cancelSwitchShift"
    />
</template>

<script lang="ts" setup>
import { ref, nextTick, computed, watch } from "vue";
import dayjs from "dayjs";
import { ArrowDown, ArrowUp, CopyDocument } from "@element-plus/icons-vue";
import IconSvg from "@/layouts/IconBase.vue";
import useTimesheetEntryDetail from "@/composables/v2/useTimesheetEntryDetail";
import TimePicker from "@/components/TimePicker.vue";
import TimesheetEntryTotal from "@/components/v2/TimesheetEntryTotal.vue";
import RentalTaskDetail from "@/components/v2/RentalTaskDetail.vue";
import ForceTaskDetail from "@/components/v2/ForceTaskDetail.vue";
import ConfirmDialog from "@/components/v2/ConfirmDialog.vue";
import { useStore } from "vuex";
import { TASK_TYPES_VALUE, USER_TYPE_SYSTEM_ADMINISTRATOR } from "core/constants";
import { COMPANY_IDS } from "@/composables/v2/types";
import { diffMinutes } from "@/utils/time";
import resourceService from "@/services/resource.service";

const props = defineProps<{
  isEditMode?: boolean;
  disabled?: boolean;
  timesheetData?: any; // Pass timesheet data to access staff resource info
}>();

const store = useStore();
const currentUser = computed(() => store.getters["auth/currentUser"]);
const staffCompanyAccess = ref({
  rental: false,
  force: false,
  loaded: false,
});

const normalizeCompanyId = (companyId?: string) => (companyId || "").trim().toLowerCase();

const getStaffWorkerId = () => {
  const staffUser = props.timesheetData?.User || props.timesheetData?.user;
  return staffUser?.WorkerId || staffUser?.workerId || null;
};

const isStaffSystemAdmin = () => {
  const staffUser = props.timesheetData?.User || props.timesheetData?.user;
  const userType = staffUser?.UserType ?? staffUser?.userType;
  return userType === USER_TYPE_SYSTEM_ADMINISTRATOR || userType === 3 || userType === "3";
};

const loadStaffCompanyAccess = async () => {
  const isApproverEditMode = props.isEditMode && props.timesheetData;
  const isOwner = props.timesheetData?.userId === currentUser.value?.userId;
  if (!isApproverEditMode || isOwner) {
    staffCompanyAccess.value = { rental: false, force: false, loaded: false };
    return;
  }

  const workerId = getStaffWorkerId();
  if (!workerId) {
    staffCompanyAccess.value = { rental: false, force: false, loaded: false };
    return;
  }

  try {
    const response = await resourceService.getResourcesByWorker(workerId);
    const resources = Array.isArray(response?.value) ? response.value : (Array.isArray(response) ? response : []);
    const companies = resources
      .map((resource: any) => normalizeCompanyId(resource?.CompanyID || resource?.companyId))
      .filter(Boolean);

    staffCompanyAccess.value = {
      rental: companies.includes(COMPANY_IDS.RENTAL),
      force: companies.includes(COMPANY_IDS.FORCE),
      loaded: true,
    };
  } catch (_error) {
    staffCompanyAccess.value = { rental: false, force: false, loaded: false };
  }
};

const disabledDate = (time: Date) => {
  return time.getTime() > Date.now()
}



// Task type display logic based on user's taskType setting
// 0 = All (show both Rental and Force)
// 1 = Rental only  
// 2 = Force only (JobCost)
// IMPORTANT: For approvers editing submitted timesheets, restrict based on staff's taskType
const taskTypeDisplay = computed(() => {
  const userTaskType = currentUser.value?.taskType;
  const isSystemAdmin =
    currentUser.value?.userType === USER_TYPE_SYSTEM_ADMINISTRATOR;
  const isApproverEditMode = props.isEditMode && props.timesheetData;
  const isOwner = props.timesheetData?.userId === currentUser.value?.userId;
  const isApprover = isApproverEditMode && !isOwner;
  
  const showConfig = {
    rental: false,
    force: false,  // JobCost in V1 = Force in V2
  };

  if (isSystemAdmin && !isApprover) {
    showConfig.rental = true;
    showConfig.force = true;
    return showConfig;
  }
  
  if (isApprover) {
    if (isStaffSystemAdmin()) {
      showConfig.rental = true;
      showConfig.force = true;
      return showConfig;
    }

    if (staffCompanyAccess.value.loaded) {
      showConfig.rental = staffCompanyAccess.value.rental;
      showConfig.force = staffCompanyAccess.value.force;

      if (showConfig.rental || showConfig.force) {
        return showConfig;
      }
    }

    // Approver mode: Restrict task types based on staff's taskType setting
    const staffUser = props.timesheetData?.User || props.timesheetData?.user;
    const staffTaskType = staffUser?.TaskType;
    
    if (staffTaskType === TASK_TYPES_VALUE.All || staffTaskType === undefined || staffTaskType === null) {
      // Staff has All (0) or undefined = Approver can add both Rental and Force
      showConfig.rental = true;
      showConfig.force = true;
    } else if (staffTaskType === TASK_TYPES_VALUE.Rental) {
      // Staff has Rental (1) = Approver can only add Rental tasks
      showConfig.rental = true;
      showConfig.force = false;
    } else if (staffTaskType === TASK_TYPES_VALUE.JobCost) {
      // Staff has JobCost (2) = Approver can only add Force tasks
      showConfig.rental = false;
      showConfig.force = true;
    } else {
      // Fallback: If staff taskType is not found, allow all
      // console.warn('Staff taskType not found, allowing all task types');
      showConfig.rental = true;
      showConfig.force = true;
    }
  } else {
    // Normal mode (staff creating their own timesheet): Use user's taskType setting
    if (userTaskType === TASK_TYPES_VALUE.All || userTaskType === undefined || userTaskType === null) {
      // 0 or undefined = show all
      showConfig.rental = true;
      showConfig.force = true;
    } else if (userTaskType === TASK_TYPES_VALUE.Rental) {
      // 1 = Rental only
      showConfig.rental = true;
    } else if (userTaskType === TASK_TYPES_VALUE.JobCost) {
      // 2 = Force/JobCost only
      showConfig.force = true;
    }
  }
  
  return showConfig;
});

watch(
  () => [props.isEditMode, props.timesheetData?.userId, getStaffWorkerId()],
  () => {
    loadStaffCompanyAccess();
  },
  { immediate: true }
);

// Default task type for new lines based on allowed task types
const defaultTaskType = computed(() => {
  return taskTypeDisplay.value.rental ? 'Rental' : 'Force';
});

const { state, removedLineIds, totalHoursDisplay, totalMinsDisplay, addLine: addLineFromComposable, removeLine, duplicateLine, toggleExpanded, setType, setShift, setStartDate, setLineDuration, resetForm: resetFormComposable, validateWorkingTime, loadTimesheetData: loadTimesheetDataFromComposable } = useTimesheetEntryDetail();

// Wrapper for addLine to use correct default task type
const addLine = () => {
  addLineFromComposable();
  // Override the type of the newly added line with correct default
  const newLine = state.lines[state.lines.length - 1];
  if (newLine) {
    newLine.type = defaultTaskType.value;
  }
};

// Wrapper for loadTimesheetData to fix default type when no lines exist
const loadTimesheetData = (timesheetData: any) => {
  loadTimesheetDataFromComposable(timesheetData);
  
  // Fix type for all lines that match the default type pattern
  // This handles the case where loadTimesheetData is called multiple times
  // (first with incomplete data, then with full User.Resource data)
  const linesFromTimesheetData = timesheetData?.timesheetLines || timesheetData?.TimesheetLines || [];
  
  if (linesFromTimesheetData.length === 0 && state.lines.length > 0) {
    // No lines from server - these are default/new lines, fix their types
    state.lines.forEach((line) => {
      line.type = defaultTaskType.value;
    });
  }
};

// Watch for changes in taskTypeDisplay (e.g., when User.Resource data loads)
// and auto-fix default line types
watch(
  () => taskTypeDisplay.value,
  (newDisplay, oldDisplay) => {
    // Only fix if we're in edit mode and taskTypeDisplay actually changed
    if (!props.isEditMode) return;
    
    const oldRental = oldDisplay?.rental ?? false;
    const oldForce = oldDisplay?.force ?? false;
    const newRental = newDisplay.rental;
    const newForce = newDisplay.force;
    
    // Check if display config meaningfully changed
    if (oldRental === newRental && oldForce === newForce) return;
    
    // Fix all lines that don't have originalData (i.e., new/default lines)
    state.lines.forEach((line) => {
      if (!line.originalData || !line.originalLineId) {
        // This is a new line (not loaded from server)
        line.type = defaultTaskType.value;
      }
    });
  },
  { deep: true }
);

const datePickerStartDate = ref<any>(null);

const workingTimeErrorMessage = ref<string | null>(null);
const workingTimeIsValid = ref<boolean>(true);

const rentalTaskRefs = ref<any[]>([]);
const taskRefById = ref<Record<string, any>>({});

const addRentalTaskRef = (ref: any) => {
  if (ref) {
    const id = ref.taskId ?? ref?.$?.props?.taskId;
    if (id) {
      // Check if ref for this taskId already exists
      const existingIndex = rentalTaskRefs.value.findIndex((r: any) => 
        r && (r.taskId === id || r?.$?.props?.taskId === id)
      );
      if (existingIndex >= 0) {
        // Replace existing ref (happens when switching Rental <-> Force)
        rentalTaskRefs.value[existingIndex] = ref;
      } else {
        rentalTaskRefs.value.push(ref);
      }
      taskRefById.value[id] = ref;
    } else {
      rentalTaskRefs.value.push(ref);
    }
  }
};

const validateAllForms = async () => {

  
  if (rentalTaskRefs.value.length === 0) {
    return true;
  }
  
  const validationPromises = rentalTaskRefs.value.map((ref, index) => {
    return new Promise((resolve) => {
      if (ref && ref.formRef && ref.formRef.validate) {
        ref.formRef.validate((valid: boolean) => {
          resolve(valid);
        });
      } else {
        resolve(true);
      }
    });
  });
  
  const results = await Promise.all(validationPromises);
  const allValid = results.every(result => result === true);
  
  return allValid;
};

defineExpose({
  validateAllForms,
  rentalTaskRefs,
  state,
  removedLineIds,
  loadTimesheetData,
  resetForm: () => {
    resetFormComposable();
    rentalTaskRefs.value.forEach(ref => {
      if (ref?.formRef?.resetFields) {
        ref.formRef.resetFields();
      }
    });
    rentalTaskRefs.value = [];
    taskRefById.value = {};
    
    workingTimeErrorMessage.value = null;
    workingTimeIsValid.value = true;
    
    // Fix default type for the initial line after reset
    if (state.lines.length === 1) {
      state.lines[0].type = defaultTaskType.value;
    }
  },
  validateWorkingTime: () => {
    const result = validateWorkingTime();
    workingTimeErrorMessage.value = result.message;
    workingTimeIsValid.value = result.isValid;
    return result;
  }
});
const onDateFocus = () => {
    // open popper programmatically to avoid focus quirks
    datePickerStartDate.value?.handleOpen?.();
};

type Hm = { hours: number; minutes: number; isAm: boolean };
const toHM = (d?: Date): Hm => {
    if (!d) return { hours: 12, minutes: 0, isAm: true };
    const hours24 = d.getHours();
    const minutes = d.getMinutes();
    const isAm = hours24 < 12;
    let hours = hours24 % 12;
    if (hours === 0) hours = 12;
    return { hours, minutes, isAm };
};

const onChangeValidTime = (_msg: string) => {
    // placeholder for future validation UI
};

const onSubmitTime = (payload: { hours: number; minutes: number; isAm: boolean }, additionValues: { id: string; isStartTime?: boolean; isEndTime?: boolean }) => {
    const { id, isStartTime } = additionValues;
    const line = state.lines.find(l => l.id === id);
    if (!line) return;
  let hours24 = payload.isAm ? payload.hours % 12 : (payload.hours % 12) + 12;
  if (payload.isAm && payload.hours === 12) hours24 = 0;
  if (!payload.isAm && payload.hours === 12) hours24 = 12;
  const t = dayjs().hour(hours24).minute(payload.minutes).second(0).millisecond(0);
  if (isStartTime) line.startTime = t.toDate(); else line.endTime = t.toDate();
};


type TaskType = 'Rental' | 'Force';
const showSwitchConfirm = ref(false);
const showShiftSwitchConfirm = ref(false);
const pendingShift = ref<boolean | null>(null);
const pendingSwitch = ref<{ lineId: string; target: TaskType } | null>(null);

const lineHasData = (line: any) => {
  const comp = taskRefById.value[line.id] || rentalTaskRefs.value.find((r: any) => r && (r.taskId === line.id || r?.$?.props?.taskId === line.id));
  if (comp?.hasData) return !!comp.hasData();
  return false;
};

const onRequestSwitchType = (line: any, target: TaskType) => {
  if (line.type === target) return;
  if (lineHasData(line)) {
    pendingSwitch.value = { lineId: line.id, target };
    showSwitchConfirm.value = true;
    return;
  }
  // No data - switch directly and clear any residual originalData
  const theLine = state.lines.find(l => l.id === line.id);
  if (theLine) {
    theLine.originalData = undefined;
    theLine.originalLineId = undefined;
  }
  setType(line.id, target);
};

const confirmSwitchType = () => {
  if (!pendingSwitch.value) return;
  const comp = taskRefById.value[pendingSwitch.value!.lineId] || rentalTaskRefs.value.find((r: any) => r && (r.taskId === pendingSwitch.value!.lineId || r?.$?.props?.taskId === pendingSwitch.value!.lineId));
  if (comp?.formRef?.resetFields) comp.formRef.resetFields();
  // Clear originalData so the new component starts fresh (no old site/job data carried over)
  const line = state.lines.find(l => l.id === pendingSwitch.value!.lineId);
  if (line) {
    line.originalData = undefined;
    line.originalLineId = undefined;
  }
  setType(pendingSwitch.value.lineId, pendingSwitch.value.target);
  pendingSwitch.value = null;
  showSwitchConfirm.value = false;
};

const cancelSwitchType = () => {
  pendingSwitch.value = null;
  showSwitchConfirm.value = false;
};

// Check if any line has data entered
const hasAnyLineData = (): boolean => {
  return state.lines.some(line => lineHasData(line));
};

// Request shift change - show confirmation if data exists
const onRequestSwitchShift = (isNight: boolean) => {
  if (state.shift === isNight) return; // Already on this shift
  
  if (hasAnyLineData()) {
    pendingShift.value = isNight;
    showShiftSwitchConfirm.value = true;
    return;
  }
  
  setShift(isNight);
};

const confirmSwitchShift = () => {
  if (pendingShift.value !== null) {
    setShift(pendingShift.value);
  }
  pendingShift.value = null;
  showShiftSwitchConfirm.value = false;
};

const cancelSwitchShift = () => {
  pendingShift.value = null;
  showShiftSwitchConfirm.value = false;
};

// Handle duplicate/copy task - gets current task data and passes to duplicateLine
const handleDuplicateLine = (lineId: string) => {
  // Find the task component ref for this line
  const comp = taskRefById.value[lineId] || rentalTaskRefs.value.find((r: any) => 
    r && (r.taskId === lineId || r?.$?.props?.taskId === lineId)
  );
  
  // Get task data from the component if available
  let taskData = undefined;
  if (comp?.getTaskData) {
    taskData = comp.getTaskData();
  }
  
  // Call duplicateLine with the task data
  duplicateLine(lineId, taskData);
};
</script>

<style lang="scss">
.timesheet-entry-detail {
    .btn-add-task {
        width: 153px;
    }

    .btn-shift {
        width: 130px;
        border: none;
    }
    .task-type-selected {
        border-radius: 6px;
    }

    .task-type {
        width: 136px;
    }

    .rounded-group-button {
        border-radius: 8px;
        padding: 2px;
        overflow: hidden;
        background-color: #DEDEDE;
    }

}
.job-type {
  height: 36px;
  padding: 8px 32px;
}
</style>
